import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import AboutAuthor from "../components/AboutAuthor";
import AboutBook from "../components/AboutBook";
import Stories from "../components/Stories";
import FreeStory from "../components/FreeStory";
import Works from "../components/Works";
import Praise from "../components/Praise";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function Landing() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <AboutAuthor />
        <AboutBook />
        <Stories />
        <FreeStory />
        <Works />
        <Praise />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
